import { getUserAgreementPath } from '@/lib/utils/terms';

export const TERMS_MAP = {
  acceptableUsePolicyLink: {
    contentKey: 'acceptableUsePolicy',
    path: 'ua/acceptableuse-full',
  },
  buyerProtectionLink: {
    contentKey: 'buyerProtection',
    path: 'ua/paypal-buyer-protection',
  },
  cfsgpdsLink: {
    contentKey: 'cfsgpds',
    path: 'ua/cfsgpds-full',
  },
  collectionNoticeLink: {
    contentKey: 'collectionNotice',
    path: 'ua/ppcollection-notice',
  },
  commissionInformationLink: {
    // Commission Information is the same as Fee Information for some countries
    contentKey: 'commissionInformation',
    useFunction: 'feeInformation',
  },
  countryUserAgreementLink: {
    contentKey: 'countryUserAgreement',
    getDynamicPath: getUserAgreementPath,
  },
  creditCheckLink: {
    contentKey: 'creditCheck',
    path: 'ua/creditchk',
  },
  eCommunicationsPolicyLink: {
    contentKey: 'eCommunicationsPolicy',
    path: 'ua/esign-full',
  },
  eSignConsent: {
    contentKey: 'eSignConsent',
    path: 'ua/esign-full',
  },
  eSignDisclosureAndConsent: {
    contentKey: 'eSignDisclosureAndConsent',
    path: 'ua/esign-full',
  },
  feeInformationLink: {
    contentKey: 'feeInformation',
    useFunction: 'feeInformation',
  },
  nonAccountCheckoutLink: {
    contentKey: 'privacyPolicy',
    path: 'ua/privacy-full',
  },
  paymentServicesActLink: {
    contentKey: 'paymentServicesAct',
    path: 'corporate/payment-services-act',
  },
  paypalUserAgreementLink: {
    contentKey: 'paypalUserAgreement',
    getDynamicPath: getUserAgreementPath,
  },
  privacyPolicyLink: {
    contentKey: 'privacyPolicy',
    path: 'ua/privacy-full',
  },
  rightOfWithdrawalLink: {
    contentKey: 'rightOfWithdrawal',
    useFunction: 'rightOfWithdrawal',
  },
  safetyAndSecurityLink: {
    contentKey: 'safetyAndSecurity',
    path: 'ua/paypal-safety-and-security',
  },
  sanctionsLink: {
    contentKey: 'sanctions',
    path: 'support/overseasremittance',
  },
  serviceDescriptionLink: {
    contentKey: 'serviceDescription',
    path: 'ua/servicedescription-full',
  },
  termsAndConditionsLink: {
    contentKey: 'termsAndConditions',
    path: 'ua/legalhub-full',
  },
  termsLink: {
    contentKey: 'terms',
    path: 'ua/privacywax-full',
  },
  userAgreementLink: {
    contentKey: 'userAgreement',
    getDynamicPath: getUserAgreementPath,
    testId: 'user-agreement-link',
  },
} as const;

export type TermsMapKey = keyof typeof TERMS_MAP;

export const RIGHT_OF_WITHDRAWAL_TERM_KEY = 'terms.signupRightOfWithdrawal';
